/**
 * SectionHeader Component
 * 
 * A header component with icon, title, and description for configuration sections.
 * 
 * @param {string} title - Section title
 * @param {string} description - Section description
 * @param {React.ReactNode} icon - Icon element (SVG)
 * @param {string} color - Accent color: "blue", "rose", "amber", "indigo" (default: "indigo")
 */

const COLOR_CLASSES = {
  blue: {
    container: "bg-blue-100",
    icon: "text-blue-600",
  },
  rose: {
    container: "bg-rose-100",
    icon: "text-rose-600",
  },
  amber: {
    container: "bg-amber-100",
    icon: "text-amber-600",
  },
  indigo: {
    container: "bg-indigo-100",
    icon: "text-indigo-600",
  },
};

export default function SectionHeader({
  title,
  description,
  icon,
  color = "indigo",
}) {
  const colors = COLOR_CLASSES[color] || COLOR_CLASSES.indigo;

  return (
    <div className="flex items-center gap-3 pb-4 border-b border-gray-200">
      <div className={`w-10 h-10 ${colors.container} rounded-lg flex items-center justify-center`}>
        <span className={`w-5 h-5 ${colors.icon}`}>
          {icon}
        </span>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-gray-500 text-sm">{description}</p>
      </div>
    </div>
  );
}